import { Backdrop, Box, CircularProgress, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState,useRef } from "react";
import footerImg from "../../assets/footer.png";
import HorizontalMenuItems from "./HorizontalMenuItem";
import SelectMenuItemComponent from "./SelectMenuItemComponent";
import {useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setWebshopCategoryData, setWebshopLoading, updateSelectedMenuItem, updateWebShopMenuPosition } from "../../store/slice/Webshop.slice";
import { IMG_BASE_URL, getHeight } from "../../utils/utils";
import { FetchWebShopCategories } from "../../api/Webshop.service";

const Menubar = ({getProductList,getProductsInfo}) => {
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);

  const menuCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Checkout fields + sidemnu"
  )?.fields

  const theme = useTheme();
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const {widgetSetupId} = useSelector(
    (store) => store?.widgetSettings
  );
  const {webShopMenuPosition,webShopCategoryList,selectedMenuItem,webshopLoading,defaultLanguage,webshopSettings,addToCartProducts}=useSelector((store)=>store?.Webshop)
  const {key,resType}=useSelector((store)=>store?.widgetSettings)
  const position = webShopMenuPosition;
  const [isScrollable, setIsScrollable] = useState(false);
  const [scrollOffset, setScrollOffset] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(true);
  const handleError = () => {
    setImageLoaded(false);
  };



  const handleMenuClick = (item)=>{
    getProductList(item)
    getProductsInfo(key,defaultLanguage)
    dispatch(updateSelectedMenuItem(item))
    navigate('/webshopMenuItem' )
  }

  const getCategories = async () => {
    try {
        const response = await FetchWebShopCategories(key, defaultLanguage,widgetSetupId)
        if (response?.status != 200) {
            console.error("Error fetching categories widget:", response);
            return;
        }
        else {
            dispatch(setWebshopCategoryData(response?.data));
            dispatch(updateSelectedMenuItem(response?.data[0]))
        }
        dispatch(setWebshopLoading(false))

    } catch (error) {
        console.error("Error fetching categories widget:", error?.message);
        dispatch(setWebshopLoading(false))
    }
}

  useEffect(()=>{
    getCategories()
    getProductList(selectedMenuItem)
    getProductsInfo(key,defaultLanguage)
    dispatch(updateSelectedMenuItem(selectedMenuItem))
    
  },[defaultLanguage])

  if(webshopLoading){
    <Backdrop
    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
    open={webshopLoading}
    onClick={()=>dispatch(setWebshopLoading(false))}
  >
    <CircularProgress color="inherit" />
  </Backdrop> 
  }
  useEffect(()=>{
    if(!webShopMenuPosition){
      let position= webshopSettings?.widgetMenu == 1 ? 'horizontal' : webshopSettings?.widgetMenu == 2 ? 'vertical' : null
      dispatch(updateWebShopMenuPosition(position) )
    }

  },[webShopMenuPosition])
  const scrollRef = useRef(null);
  const [showScrollArrow, setShowScrollArrow] = useState(false);

  useEffect(() => {
    const handleScrollVisibility = () => {
      const el = scrollRef.current;
      if (el) {
        setShowScrollArrow(el.scrollHeight > el.clientHeight);
      }
    };

    handleScrollVisibility();
    window.addEventListener("resize", handleScrollVisibility);
    return () => window.removeEventListener("resize", handleScrollVisibility);
  }, []);



  return (
    <Box id='menubar'>
      {webShopMenuPosition == "vertical"  ?
       (
      <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: isSmallScreen ? "90px" : "120px",
        backgroundColor:menuCss?.menuListBgClr,
        pt: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        zIndex: 900,
        borderRight: "1px solid #ddd",
      }}
    >

      <Box
        ref={scrollRef}
        sx={{
          overflowY: "auto",
          maxHeight: "calc(100vh - 80px)",
          flexGrow: 1,
          position: "relative",
          overflowY: 'scroll',     
          scrollbarWidth: 'none', 
          '-ms-overflow-style': 'none', 
          '&::-webkit-scrollbar': {
            display: 'none',
          },  
        }}
      >
        {webShopCategoryList?.map((item, i) => (
          <Box
            key={item?.idCategory}
            sx={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => handleMenuClick(item)}
          >
            <Box
              sx={{
                margin: "10px 0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: '100%',
                height: '100%',
                p:1,
                backgroundColor:
                  selectedMenuItem?.name === item?.name
                    ? menuCss?.menuListHighlightBgClr
                    : "transparent",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: menuCss?.menuListHoverBgClr ?? "#FF8B5A",
                  cursor: "pointer"
                }
              }}
            >
              {item?.imageFileName ? (
                <img
                  src={`${IMG_BASE_URL}/upload/WebshopCategory${item.imageFileName.replace(/\\/g, "/")}`}
                  alt={item?.name}
                  style={{
                    width: "65%",
                    height: "60%",
                    borderRadius: "8px",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ) : null}
              <Typography
                sx={{
                  textAlign: "center",
                  color:
                    selectedMenuItem?.name === item?.name
                      ? menuCss?.menuListHighlightTextClr
                      : menuCss?.menuListTextClr,
                  fontSize: "11px",
                }}
              >
                {item?.name}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80px",
          py: 2,
        }}
      >
        <img
          src={footerImg}
          alt="footerLogo"
          style={{ minWidth: "76px", height: "auto" }}
        />
      </Box>
    </Box>
    
      
      
      )
      :webShopMenuPosition == "horizontal" ?  (
        <HorizontalMenuItems  MenuItems={webShopCategoryList} handleMenuClick={handleMenuClick} />
      )
      :
        <SelectMenuItemComponent  handleMenu={handleMenuClick} />
      }
      
    </Box>
  );
};

export default Menubar;
